import firebase from "datastore/database";
import store from "datastore/store";

function chunkArray(arr, size) {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}

export default function observeBusinessGroups(userBusinesses) {
  if (!userBusinesses || !userBusinesses.length) return;
  store.dispatch({ type: "ADD_BUSINESS_GROUPS_LOADING" });

  const userBusinessUids = userBusinesses.map(
    (business) => business.businessUid
  );
  const userBusinessesesObj = {};
  for (const business of userBusinesses) {
    userBusinessesesObj[business.businessUid] = business.active;
  }

  const combinedGroupDocs = {};

  const updateGroupResults = async () => {
    const groupResults = {};
    const uniqueBusinessIds = new Set();

    for (const groupId in combinedGroupDocs) {
      const groupData = combinedGroupDocs[groupId];
      const groupUids = groupData.uids || [];

      const matchedUids = groupUids.filter((uid) =>
        userBusinessUids.includes(uid)
      );
      groupResults[groupId] = { matchedUids, businesses: [] };
      matchedUids.forEach((uid) => uniqueBusinessIds.add(uid));
    }

    if (uniqueBusinessIds.size === 0) {
      store.dispatch({
        type: "ADD_BUSINESS_GROUPS_SUCCESS",
        groups: groupResults,
      });
      return;
    }

    const businessIdsArray = Array.from(uniqueBusinessIds);
    const businessChunks = chunkArray(businessIdsArray, 10);

    try {
      const businessQueries = businessChunks.map((chunk) =>
        firebase
          .firestore()
          .collection("businesses")
          .where(firebase.firestore.FieldPath.documentId(), "in", chunk)
          .get()
      );
      const querySnapshots = await Promise.all(businessQueries);

      const businessMap = {};
      querySnapshots.forEach((snapshot) => {
        snapshot.forEach((doc) => {
          businessMap[doc.id] = doc.data();
        });
      });

      for (const groupId in groupResults) {
        const { matchedUids } = groupResults[groupId];
        groupResults[groupId].businesses = matchedUids
          .map((businessUid) => {
            const data = businessMap[businessUid];
            return data
              ? {
                  uid: businessUid,
                  name: data.name,
                  address: data.address,
                  active: userBusinessesesObj[businessUid],
                  isActiveBusiness: data.active,
                }
              : null;
          })
          .filter(Boolean);
      }

      store.dispatch({
        type: "ADD_BUSINESS_GROUPS_SUCCESS",
        groups: groupResults,
      });
    } catch (error) {
      store.dispatch({ type: "ADD_BUSINESS_GROUPS_ERROR", error });
    }
  };

  const userChunks = chunkArray(userBusinessUids, 10);

  userChunks.forEach((chunk) => {
    firebase
      .firestore()
      .collection("business-groups")
      .where("uids", "array-contains-any", chunk)
      .onSnapshot(
        (snapshot) => {
          snapshot.docs.forEach((doc) => {
            combinedGroupDocs[doc.id] = doc.data();
          });

          updateGroupResults();
        },
        (error) => {
          store.dispatch({ type: "ADD_BUSINESS_GROUPS_ERROR", error });
        }
      );
  });
}
